<app-navbar></app-navbar>
<router-outlet class="p-5"></router-outlet>
